import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import styled from 'styled-components'

const SuccessContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`

const MessageCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
`

function OAuthSuccess() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const handleSuccess = async () => {
      console.log('🔄 Processing OAuth success...')
      console.log('Search params:', Object.fromEntries(searchParams.entries()))
      
      try {
        // Get the auth data from URL parameters
        const dataParam = searchParams.get('data')
        
        if (!dataParam) {
          console.error('❌ No authentication data received in URL parameters')
          throw new Error('No authentication data received')
        }

        // Parse the auth data
        const authData = JSON.parse(decodeURIComponent(dataParam))
        console.log('✅ Auth data received:', authData)

        if (!authData.access_token) {
          throw new Error('No access token received')
        }

        // Store the token and user data
        await login(authData.access_token, authData.user)
        console.log('✅ User logged in successfully')
        
        // Redirect to dashboard
        navigate('/dashboard')
        
      } catch (error) {
        console.error('❌ Failed to process authentication:', error)
        navigate('/login?error=auth_failed')
      }
    }

    handleSuccess()
  }, [login, navigate, searchParams])

  return (
    <SuccessContainer>
      <MessageCard>
        <h2>Success!</h2>
        <p>You have been successfully authenticated.</p>
        <p>Redirecting to your dashboard...</p>
        <div style={{ marginTop: '1rem' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #f3f4f6',
            borderTop: '4px solid #10b981',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </MessageCard>
    </SuccessContainer>
  )
}

export default OAuthSuccess
